export default __webpack_public_path__ + "static/media/about.59e83103.jpg";